import * as axiosAPI from '../../api/admin/default';
import * as axiosAPIBlog from '../../api/admin/blog';
import * as axiosAPICategory from '../../api/admin/category';
import * as axiosAPIPage from '../../api/admin/page';

window.activePageID;
window.activePageName;
window.activeSlug;
window.activeSlugID;
window.activePageType;
window.activeId, window.eleActive;
window.currentPageData = {};
window.initPageOption = false;
window.currentPageID;
window.currentSlugID;
window.currentPageType;
window.activeType;
window.activeBlogId;
window.activeBlogname;
window.activeIndexKey;
window.blogindex;

import * as customIconJStree from '../../global/jstreeiconstatus';

(async function ($) {
    RVwys.plugin['Rightbar'] = true;
    RVwys.rigthbar = {};
    RVwys.rigthbar.responseOptionCategory = {};
    RVwys.rigthbar.isJstree = {};
    RVwys.rigthbar.isJstree.page = {};
    RVwys.rigthbar.isJstree.blog = {};

    $(document).bind('editorReady', function () {
        // Pagebar
        var fb = $('#frameBody').get(0).contentWindow;
        var pageMetatag, pageCss, pageJs, sidebarStyle;
        // Get Current Page Option
        if (typeof parent.currentPageJSON != 'undefined') {
            var dataPas = parent.currentPageJSON;
            const iconVisibility = {
                ...customIconJStree.JStreeTypeIconPage(),
                ...customIconJStree.JStreeTypeIconBlog(),
                ...customIconJStree.JStreeTypeIconSystem(),
                ...customIconJStree.JStreeTypeIconHome(),
            };

            $('#CurrenttypeIcon').addClass(iconVisibility[dataPas.type].icon);

            if (dataPas.statusIcon.match(/draft/)) {
                $('#CurrenttypeIcon')
                    .closest('.sprite-icon-visibility')
                    .css('opacity', '0.5');
            }

            parent.currentPageID = dataPas.id;
            parent.activePageID = dataPas.id;
            parent.activePageName = dataPas.page_name;
            parent.activeSlug = dataPas.slug.slug_name;
            parent.currentSlugID = dataPas.slug_id;
            parent.currentPageType = dataPas.slug_type;

            $('.current-optionPage').attr('page-id', dataPas.id);
            $('.current-optionPage').attr('page-slug', dataPas.slug.slug_name);
            $('.current-optionPage').attr('page-name', dataPas.page_name);
            $('.current-optionPage').attr('is-pulbic', dataPas.is_published);
            $('.current-optionPage').attr('is-homepage', dataPas.is_homepage);
            $('.current-optionPage').attr('slug-id', dataPas.slug_id);
            $('.current-optionPage').attr('type', dataPas.type);

            //					$('#CurrentType').text(dataPas.slug_type);
        }

        console.log($('.current-optionPage'));

        $('.current-optionPage').click(function () {
            RVwys.hidePanelAll();
            parent.activePageID = $('.current-optionPage').attr('page-id');
            parent.activePageName = $('.current-optionPage').attr('page-name');
            parent.activeSlug = $('.current-optionPage').attr('page-slug');

            var type = currentPageType == 'Category' ? true : false;
            var isTypeSystem = $('.current-optionPage')
                .attr('type')
                .match('system');

            $('.pageSetting,.wys-rowTwo').hide();
            $('.bar-right,.bar-category').addClass('bar-category-hidden');
            //alert('sss')
            $('.rvsb-design-property').hide();
            $('.current-pageSetting').css({
                right: '50px',
                top: '120px',
            });
            var $this = $(this);
            var isPublic = $this.attr('is-pulbic') == 1 ? true : false;
            var isHomepage =
                $this.attr('is-homepage') === 'true' ? true : false;

            $('#currentUnsetHide').toggle(!isPublic);
            $('#currentSetHide').toggle(isPublic);

            if (isPublic) {
                switch (currentPageType.toLowerCase()) {
                    case 'system':
                        $('#currentRenamePage').toggle(isHomepage);
                        $('#currentSetHide').toggle(isHomepage);
                        $('#currentSetHomePage').toggle(isHomepage);
                        $('#currentSetHide').toggle(type);
                        $('#currentDuplicate').toggle(type);

                        $('#currentUnsetHide').hide();

                        var blogIndex =
                            parent.activeSlug == 'blog' ? true : false;

                        $('#currentVisibility').toggle(blogIndex);

                        break;
                    case 'post':
                    case 'page':
                    case 'category':
                        $('#currentSetHomePage').toggle(!isHomepage);
                        $('#currentDuplicate').toggle(!type);

                        if (isTypeSystem) {
                            $('#currentRenamePage').toggle(isHomepage);
                            $('#currentSetHide').toggle(isHomepage);
                            $('#currentSetHomePage').toggle(isHomepage);
                            $('#currentSetHide').toggle(type);
                            $('#currentDuplicate').toggle(type);

                            $('#currentVisibility').hide();
                        }
                        $('#currentUnsetHide').hide();
                        break;
                    default:
                        break;
                }
            }
        });

        // Start Active Category Section name
        $('.rvsb-design-bar-right .rightmenu-icon').click(function () {
            $('.rightmenu-icon').removeClass('active-site');
            $(this).addClass('active-site');
            console.log($(this).parent().find('.rightmenu-icon').length);
        });
        // End Active Site Section name

        // addPage
        fb.$('.addPage').click(function () {
            RVwys.addPageModal();
        });

        $('#currentUnsetHide,#currentSetHide').click(function () {
            const checkStatus =
                $(this).attr('id') == 'currentSetHide'
                    ? { public: '0', opacity: '0.5' }
                    : { public: '1', opacity: '' };

            console.log('$(this): ', $(this));
            axiosAPI
                .axiosSetHideorUnhide({
                    slug_id: parent.currentSlugID,
                })
                .then(result => {
                    $('.current-optionPage').attr(
                        'is-pulbic',
                        checkStatus.public
                    );
                    $('.current-optionPage').trigger('click');

                    var elemLi = fb.$(
                        `.liListPage[slug-id="${parent.currentSlugID}"],.liListPost[slug-id="${parent.currentSlugID}"]`
                    );
                    elemLi
                        .find('.editPage')
                        .attr('is-pulbic', checkStatus.public);
                    elemLi
                        .find('.editPageWithPageName')
                        .css('opacity', checkStatus.opacity);
                });
        });

        var editviewRename = $('#editviewRename').html();

        $('#currentRenamePage').click(function () {
            var beforeSlug = parent.activeSlug;
            console.log('beforeSlug: ', beforeSlug);

            var UI = UIkit;
            var onInsert = function () {
                axiosAPI
                    .axiosRenamePageAndPost({
                        page_name: modal.element.find('#pageName').val().trim(),
                        slug_id: parent.currentSlugID,
                    })
                    .then(resposnse => {
                        var afterSlug = resposnse.data.data.slug_name;
                        var typepage =
                            parent.currentPageType != 'Page'
                                ? 'blog'
                                : parent.currentPageType.toLowerCase();

                        parent.activePageName = resposnse.data.data.page_name;
                        CurrentSlugMySite = CurrentSlugMySite.replace(
                            beforeSlug,
                            afterSlug
                        );
                        parent.activeSlug = $('#cmsCurrent').text(
                            resposnse.data.data.page_name
                        );
                        $('.current-optionPage').attr(
                            'page-name',
                            resposnse.data.data.page_name
                        );

                        var oLi = fb.$(
                            `.liListPage[slug-id=${parent.currentSlugID}]`
                        );
                        oLi.find('.editPage').attr(
                            'page-name',
                            resposnse.data.data.page_name
                        );
                        oLi.find('.editPageWithPageName').text(
                            resposnse.data.data.page_name
                        );

                        if (resposnse.data.data.changed_menutitle) {
                            RVwys.rigthbar.isJstree.updatemenu(
                                beforeSlug,
                                resposnse.data.data
                            );
                        }

                        if (afterSlug != beforeSlug) {
                            window.history.pushState(
                                'data',
                                'Title',
                                resposnse.data.data.url
                            );

                            var slugID = parseInt(resposnse.data.data.slug_id);
                            var nameNew = resposnse.data.data.page_name;
                            var slugName = resposnse.data.data.slug_name;

                            var objDataUpdateCurrent = ([
                                'Post',
                                'Category',
                            ].includes(parent.currentPageType)
                                ? RVwys.rigthbar.isJstree.blog.findObjectOfKey
                                : RVwys.rigthbar.isJstree.page.findObjectOfKey)(
                                slugID
                            );

                            var {
                                objRecently,
                                objUpdate,
                                objCategoryUpdate,
                            } = objDataUpdateCurrent;

                            switch (parent.currentPageType) {
                                case 'Post':
                                    objRecently.text = nameNew;

                                    objUpdate.page_name = nameNew;
                                    objUpdate.text = nameNew;
                                    objUpdate.slug_name = slugName;
                                    objUpdate.post_name = nameNew;

                                    RVwys.rigthbar.isJstree.refreshBlog();
                                    RVwys.rigthbar.isJstree.refreshRecently(
                                        wex.blog.blog_recently,
                                        'RecentPost'
                                    );

                                    break;

                                case 'Category':
                                    var slugPrefix =
                                        resposnse.data.data.slug_prefix;
                                    objCategoryUpdate.text = nameNew;
                                    objCategoryUpdate.slug_name = slugName;

                                    var objUpdateChilde = parent.wex.blog.blog_lists.filter(
                                        ({ category_name }) =>
                                            category_name ==
                                            window.activeBlogname
                                    );

                                    $.map(objUpdateChilde, function (objPost) {
                                        objPost.category_name = nameNew;
                                        objPost.slug_prefix = slugPrefix;
                                    });
                                    RVwys.rigthbar.isJstree.refreshBlog();
                                    RVwys.rigthbar.isJstree.refreshRecently(
                                        wex.blog.blog_recently,
                                        'RecentPost'
                                    );

                                    break;

                                default:
                                    objRecently.text = nameNew;

                                    objUpdate.page_name = nameNew;
                                    objUpdate.text = nameNew;
                                    objUpdate.slug_name = slugName;

                                    RVwys.rigthbar.isJstree.refreshPage();
                                    RVwys.rigthbar.isJstree.refreshRecently(
                                        wex.page.page_recently,
                                        'RecentPage'
                                    );

                                    break;
                            }
                        }

                        modal.hide();
                        console.pop.success({
                            text: resposnse.data.data.message,
                            delay: 5000,
                        });
                    })
                    .catch(err => {
                        console.log('err: ', err);
                        console.pop.error({
                            text: err.data.data.message,
                        });
                    });
            };

            var oncancel = function () {
                modal.hide();
            };
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    `<div class="uk-margin uk-modal-header">
                        <h2>${rvLang('Rename')}</h2>
                        <span class="uk-modal-close uk-icon-close"></span>
                    </div>
                    <div class="uk-margin uk-modal-content">${editviewRename}</div>
                    <div class="uk-modal-footer uk-text-left clear">
                        <button class="uk-button uk-button-success  js-modal-confirm">
                        ${rvLang('Save')}</button>
                       <button class="uk-button js-modal-confirm-cancel">
                       ${rvLang('Cancel')}</button>
                    </div>`,
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
            makeSlug(modal.element);
        });

        $('#currentSetHomePage').click(function () {
            console.log(
                'Event click #currentSetHomePage: ',
                $('#currentSetHomePage')
            );

            $('.current-pageSetting').hide();

            axiosAPI
                .axiosSetToHome({ slug_id: parent.currentSlugID })
                .then(result => {
                    $('#CurrenttypeIcon')
                        .removeAttr('class')
                        .addClass('icon-visibility home-normal');
                    $('.current-optionPage').attr('is-homepage', '1');

                    //  TODO:WEX remove after make route wex API
                    // Start
                    var typebar = currentPageType.toLowerCase();

                    var indexHome = $.map(
                        parent.wex[typebar]['page_tree'],
                        obj => {
                            return obj.is_homepage;
                        }
                    ).indexOf(1);

                    if (indexHome != -1) {
                        parent.wex[typebar]['page_tree'][
                            indexHome
                        ].is_homepage = 0;
                        parent.wex[typebar]['page_tree'][indexHome].type =
                            'default';
                    }

                    var newHome = $.map(
                        parent.wex[typebar]['page_tree'],
                        obj => {
                            return obj.text;
                        }
                    ).indexOf(parent.activePageName);

                    if (newHome != -1) {
                        parent.wex[typebar]['page_tree'][
                            newHome
                        ].is_homepage = 1;
                        parent.wex[typebar]['page_tree'][newHome].type = 'home';
                    }

                    // End
                });
        });

        $('#currentDuplicate').click(function () {
            fb.$('.pageSetting').hide();
            console.log('Deuplicate page : ' + parent.activePageName);

            fb.$('.bar-page').addClass('bar-category-hidden');
            fb.$('.bar-right').hide();

            var overlaypanel = $(
                `<div class="overlaypanel">
                    <img class="loading" src="${parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
                </div>`
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });

            parent.$('body').append(overlaypanel);

            axiosAPI
                .axiosSetDuplicate({ slug_id: parent.currentSlugID })
                .then(resposnse => {
                    setTimeout(function () {
                        console.pop.success({
                            text: resposnse.data.data.message,
                            delay: 2000,
                        });

                        parent.$('.overlaypanel').remove();
                        window.location.href = resposnse.data.data.url;
                    }, 3000);
                })
                .catch(err => {
                    console.pop.error({
                        text: err.data.data.message,
                    });
                    parent.$('.overlaypanel').remove();
                });
        });

        // postbar

        // AddPost
        // START add post
        fb.$('.addPost').click(function () {
            RVwys.addPostModal();
        });
        // End Addpost
    });

    $(document).bind('designReady', function (e) {});
    // EditorReady
    $(document).bind('editorReady', function (e) {
        $('#right-bar-addpost').click(function () {
            $('#frameBody').get(0).contentWindow.$('.addPost').trigger('click');
        });
        var url = window.location.href;
        if (url.match(/\/email\/?/)) {
            $('.bar-left ').hide();
            $('.wys-email').show();
        }
        var timeout = false;
        $('#listPageSearch').keyup(function () {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                $('#listpage_onmenu').jstree(
                    'search',
                    $('#listPageSearch').val()
                );
                $('#listpage_internal').jstree(
                    'search',
                    $('#listPageSearch').val()
                );
            }, 250);
        });

        $('#listPostSearch').keyup(function () {
            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function () {
                $('#listblog').jstree('search', $('#listPostSearch').val());
                $('#RecentPost').jstree('deselect_all');
            }, 250);
        });

        $('#plugins4').jstree({
            plugins: ['search'],
        });

        $(`.bar-right-page a`).click(function () {
            RVwys.rigthbar.isJstree.refreshPage();
        });

        $('.bar-right-menu a').click(function () {
            RVwys.rigthbar.isJstree.refreshMenu();
        });

        $(`.bar-right-posts a,[onclick="bar_class('bar-post')"]`).click(
            async function () {
                if (!wex.blog.blog_first) {
                    $('.bar-category-first').addClass('bar-category-hidden');
                }

                $.each(wex.blog.blog_recently, function (k, v) {
                    wex.blog.blog_recently[k]['type'] = 'default';

                    wex.blog.blog_recently[k]['li_attr'] = {
                        'value-post': v.text,
                    };

                    wex.blog.blog_recently[k]['a_attr'] = {
                        href:
                            wex.url.WYS_SHOW_URL +
                            '/' +
                            v.slug_prefix +
                            '/' +
                            v.slug_name,
                    };
                });
                var _selectedNodeId;

                $('#RecentPost').jstree({
                    core: {
                        data: wex.blog.blog_recently,
                    },
                    types: {
                        default: {
                            icon: 'icon-visibility bpost-normal',
                        },
                    },
                    plugins: ['types', 'wholerow', 'changed'],
                });

                $('#RecentPost').bind('select_node.jstree', function (e, data) {
                    var href = data.node.a_attr.href;
                    window.location.href = href;
                });
            }
        );

        // Pagebar
        $('#setHide,.postSetting #setHide').click(function () {
            console.log('Event: setHide ID: ' + activePageID);

            axiosAPI
                .axiosSetHideorUnhide({ slug_id: activeSlugID })
                .then(result => {
                    var resultData = result.data.data;
                    RVwys.rigthbar.isJstree.Callbackoption.Hide(resultData);

                    $(this).closest('div').hide();
                    console.pop.success({
                        text: 'Set as hide ' + result.data.data.message,
                        delay: 5000,
                    });
                });
        });

        $('#unsetHide,.postSetting #unsetHide').click(function () {
            console.log('set hide page : ' + activePageID);

            axiosAPI
                .axiosSetHideorUnhide({ slug_id: activeSlugID })
                .then(result => {
                    var resultData = result.data.data;
                    RVwys.rigthbar.isJstree.Callbackoption.unHide(resultData);

                    $(this).closest('div').hide();

                    console.pop.success({
                        text: 'Set as unhide ' + result.data.data.message,
                        delay: 5000,
                    });
                });
        });

        $('#setHomePage,.postSetting #setHomePage').click(function () {
            $('.pageSetting').hide();

            axiosAPI.axiosSetToHome({ slug_id: activeSlugID }).then(result => {
                RVwys.rigthbar.isJstree.Callbackoption(
                    result.data,
                    'setHomePage',
                    activePageType
                );
                console.pop.success({
                    text: result.data.data.message,
                    delay: 5000,
                });
            });
        });

        $('#deletePage,.postSetting #deletePage').click(function () {
            var UI = UIkit;

            var oncancel = function (e) {
                modal.hide();
            };

            var onInsert = function (e) {
                axiosAPI
                    .axiosDeletePageOrPost({ slug_id: activeSlugID })
                    .then(result => {
                        RVwys.rigthbar.isJstree.Callbackoption(
                            result.data,
                            'deletePage',
                            activePageType
                        );
                        parent.$('.overlaypanel').remove();
                        console.pop.success({
                            text: result.data.data.message,
                            delay: 5000,
                        });
                    });

                modal.hide();
            };

            var type = window.activePageType == 'blog' ? 'Post' : 'Page';
            console.log('page bane:' + window.activePageName);
            var modal = UI.modal.dialog(
                [
                    `<div class="uk-margin uk-modal-header">
                    <h2>${rvLang('Delete ' + type)}</h2>
                    <span class="uk-modal-close uk-icon-close"></span>
                </div>
                <div class="uk-margin uk-modal-content">
                ${rvLang(
                    'Are you sure want to delete ' + type
                )} : ${activePageName}
                </div>
                <div class="uk-modal-footer uk-text-left clear">
                    <button class="uk-button  js-modal-confirm">${rvLang(
                        'Ok'
                    )}</button>
                    <button class="uk-button uk-button-success js-modal-confirm-cancel ">${rvLang(
                        'Cancel'
                    )}</button>
                </div>`,
                ].join('')
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.js-modal-confirm')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        });

        $('#Duplicate,.postSetting #Duplicate').click(function () {
            console.log('Deuplicate page : ' + activePageName);

            var overlaypanel = $(
                '<div class="overlaypanel">' +
                    '<img class="loading" src="' +
                    wex.url.WYS_IMG_URL +
                    'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                    '</div>'
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });
            $('body').append(overlaypanel);

            axiosAPI
                .axiosSetDuplicate({ slug_id: activeSlugID })
                .then(resposnse => {
                    $(this).closest('div').hide();

                    var resData = resposnse.data.data;
                    RVwys.rigthbar.isJstree.Callbackoption.duplicate(resData);
                    console.pop.success({
                        text: resposnse.data.data.message,
                        delay: 5000,
                    });
                });
        });

        $('#renamePage,.postSetting #renamePage').click(function (e) {
            console.log('click');

            var editviewRename = $('#editviewRename').html();
            $('#warningPageName').hide();
            $('.pageSetting').hide();

            var UI = UIkit;

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Rename') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        editviewRename +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Save') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('Cancel') +
                        '</button></div>',
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                });

            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });

            var onInsert = function () {
                if (
                    modal.element.find('#pageName').val().match(/^\s/) ==
                        null &&
                    modal.element.find('#pageName').val().trim().length > 0
                ) {
                    axiosAPI
                        .axiosRenamePageAndPost({
                            page_name: modal.element
                                .find('#pageName')
                                .val()
                                .trim(),
                            slug_id: activeSlugID,
                        })
                        .then(resposnse => {
                            RVwys.rigthbar.isJstree.Callbackoption(
                                resposnse.data,
                                'rename',
                                activePageType
                            );
                            console.pop.success({
                                text: resposnse.data.message,
                                delay: 5000,
                            });
                            modal.hide();
                        })
                        .catch(err => {
                            console.pop.error({
                                text: err.data.message,
                            });
                        });
                } else {
                    modal.element.find('#warningPageName').show();
                    modal.element.find('#pageName').focus().select();
                }
            };

            var oncancel = function () {
                modal.hide();
            };

            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            modal.show();
            makeSlug(modal.element);
        });

        $('.Visibility_Rightbar,.Siteconfig').click(async function () {
            var oThis = $(this);

            var result = await BuildIframePageProperties();
            if (result) {
                var cmd = oThis.attr('cmd-site');
                var slugname = oThis.closest('li').attr('slug-name');

                var typepage =
                    window.activePageType != 'page' ? 'post' : 'page';

                window.SiteConfigIframe.SetCurrentTab(
                    typepage,
                    window.activeSlugID,
                    cmd
                );
            }
        });

        $('.config-setting').click(async function () {
            const result = await BuildIframePageProperties();
            if (result) {
                var cmd = $(this).attr('cmd-active');
                window.SiteConfigIframe.SetCurrentTab(cmd, '', '');
            }
        });

        $('.add-page').click(function () {
            RVwys.addPageModal();
        });

        $('.add-post').click(function () {
            RVwys.addPostModal();
        });

        // Sitebar

        $('#setting-page').click(async function (e) {
            var overlaypanel = $(
                '<div class="overlaypanel overlaysite" style="position: fixed; z-index:0; "></div>'
            )
                .css({
                    width: $('body').width(),
                    height: $('body').height(),
                })
                .click(function () {
                    $('.rvsb-design-property').hide();
                    $(this).remove();
                });

            if (!$('.overlaypanel').get(0)) {
                $('body').append(overlaypanel);
            }

            $('.rightmenu-icon').removeClass('active-site');
            $('.rightmenu-icon').first().addClass('active-site');

            $('.wys-rowTwo').hide();
            $('.bar-right').addClass('bar-category-hidden');
            $('.bar-category').addClass('bar-category-hidden');

            $('.bar-right').removeClass('bar-category-hidden');
            $('.bar-page').removeClass('bar-category-hidden');

            $('#Countpage_onmenu').text(wex.page.page_tree.length);
            $('#Countpage_internal').text(wex.page.page_internal.length);

            if (wex.page.page_internal.length == 0) {
                $('.listtitle_internal').hide();
            }

            // Build JSTree

            // MENU
            RVwys.rigthbar.isJstree.createJSTrees(
                $('#listmenu'),
                { menu: wex.menu.menu_tree },
                {
                    type: 'menu',
                    iconType: {
                        ...customIconJStree.JStreeTypeIconPage(),
                        ...customIconJStree.JStreeTypeIconBlog(),
                        ...customIconJStree.JStreeTypeIconMenu(),
                    },
                }
            );

            // PAGE
            RVwys.rigthbar.isJstree.Recently();

            RVwys.rigthbar.isJstree.createJSTrees(
                $('#listpage_onmenu'),
                { page: wex.page.page_tree },
                {
                    type: 'page',
                    iconType: {
                        ...customIconJStree.JStreeTypeIconPage(),
                        ...customIconJStree.JStreeTypeIconSystem(),
                    },
                }
            );

            // Blog
            RVwys.rigthbar.callBlogAPI();

            // active right menu
            var isTypeCurrent =
                parent.currentPageType.toLowerCase() == 'category'
                    ? 'post'
                    : parent.currentPageType.toLowerCase();

            $(`[onclick="bar_class('bar-${isTypeCurrent}')"]`).trigger('click');

            if (parent.currentPageType.toLowerCase() == 'post') {
                if (!wex.blog.blog_first) {
                    $('.bar-category-first').addClass('bar-category-hidden');
                }
            }

            RVwys.hidePanelAll();
        });

        $('#rv-design-sitemap').click(function () {
            if ($('#off_sitemap').attr('aria-expanded') === 'true') {
                $(this).find('.rvsb-switch').addClass('bgoff');
            }
            if ($('#off_sitemap').attr('aria-expanded') === 'false') {
                $(this).find('.rvsb-switch').removeClass('bgoff');
            }
        });

        var fb = $('#frameBody').get(0).contentWindow;

        if (fb.$('#back-top').attr('backtotop') == 1) {
            fb.$('#back-top').css('visibility', '');
            fb.$('#back-top').show();
            $('#backtop_onoff').prop('checked', true);
        }

        $('#rv-design-backtotop').click(function () {
            if ($('#off_backtop').attr('aria-expanded') === 'true') {
                $(this).find('.rvsb-switch').addClass('bgoff');
                fb.$('#back-top').css('visibility', 'hidden');
            } else {
                $(this).find('.rvsb-switch').removeClass('bgoff');
                fb.$('#back-top').css('visibility', '');
                fb.$('#back-top').show();
            }
        });

        $('#backtop_onoff').click(function () {
            console.log(fb.$('#back-top'));
            console.log(this.checked);

            if (this.checked) {
                fb.$('#back-top').css('visibility', '');
                fb.$('#back-top').show();
                RVwys.SaveBacktoTop('1');
            } else {
                fb.$('#back-top').css('visibility', 'hidden');
                RVwys.SaveBacktoTop('0');
            }
        });
        // End sitebar
        $('#blog_setHomePage').click(function () {
            console.log('Set homepage blog index : ' + activeSlugID);

            $('.blogSetting').hide();

            axiosAPI
                .axiosSetToHome({ slug_id: activeSlugID })
                .then(result => {
                    RVwys.rigthbar.responseOptionCategory.setHomepage(
                        result.data
                    );

                    console.pop.success({
                        text: result.data.data.msg,
                        delay: 5000,
                    });
                })
                .catch(err => {
                    console.log('err: ', err);
                    console.pop.error({
                        text: err.data.data.msg,
                    });
                });
        });

        $('#blog_setHide').click(function () {
            axiosAPIBlog
                .axiosBlogSetHide({
                    slug_id: activeSlugID,
                })
                .then(response => {
                    response = response.data.data;

                    RVwys.rigthbar.responseOptionCategory.setHide(response);
                    $('.blogSetting').hide();

                    console.pop.success({
                        text: 'Set as hide ' + response.msg,
                        delay: 5000,
                    });
                })
                .catch(err => {
                    console.pop.error({
                        text: `Status Code: ${err.status} ( ${err.statusText} )`,
                        delay: 5000,
                    });
                });
        });

        $('#blog_unsetHide').click(function () {
            console.log('Set unsethide blog : ' + activeSlugID);

            axiosAPIBlog
                .axiosBlogSetHide({
                    slug_id: activeSlugID,
                })
                .then(response => {
                    response = response.data.data;
                    RVwys.rigthbar.responseOptionCategory.setUnHide(response);

                    $('.blogSetting').hide();
                    console.pop.success({
                        text: 'Unhide ' + response.msg,
                        delay: 5000,
                    });
                })
                .catch(err => {
                    console.pop.error({
                        text: `Status Code: ${err.status} ( ${err.statusText} )`,
                        delay: 5000,
                    });
                });
        });

        $('#blog_delete:not(.disable-delete)').on('click', function () {
            if (!$(this).hasClass('disable-delete')) {
                var UI = UIkit;

                var options = {
                    bgclose: false,
                    keyboard: false,
                    modal: false,
                };
                oncancel = function (e) {
                    modal.hide();
                };

                var onInsert = function (e) {
                    axiosAPICategory
                        .axiosDeleteCategory({
                            slug_id: activeSlugID,
                        })
                        .then(result => {
                            var fb = $('#frameBody').get(0).contentWindow;

                            if (
                                fb.$(
                                    `#selected_navigator [slug-id="${activeSlugID}"]`
                                )
                            ) {
                                fb.$(
                                    `#selected_navigator [slug-id="${activeSlugID}"]`
                                ).remove();
                            }

                            modal.hide();

                            wex.blog.blog_categories.splice(
                                window.activeIndexKey - 1,
                                1
                            );
                            wex.blog.blog_listscategory.splice(
                                window.activeIndexKey,
                                1
                            );

                            var connect = wex.blog.blog_lists.concat(
                                wex.blog.blog_listscategory
                            );
                            RVwys.rigthbar.isJstree.refresh(
                                $('#listblog'),
                                connect,
                                'blog'
                            );

                            $('.rvsb-design-property').hide();
                            parent.$('.overlaypanel').remove();
                            console.pop.success({
                                text: result.data.data.msg,
                                delay: 5000,
                            });
                        })
                        .catch(err => {
                            console.inline.error({
                                target: modal.element.find('.warningblogName'),
                                text: err.data.errors.category_name,
                                delay: 5000,
                            });
                        });
                };

                var modal = UI.modal.dialog(
                    [
                        '<div class="uk-margin uk-modal-header"><h2>' +
                            rvLang('Delete Page') +
                            '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                        '<div class="uk-margin uk-modal-content">' +
                            rvLang('Are you sure want to delete Category') +
                            ': ' +
                            window.activeBlogname +
                            '</div>',
                        '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                            rvLang('Ok') +
                            '</button>',
                        '<button class="uk-button js-modal-confirm-cancel ">' +
                            rvLang('Cancel') +
                            '</button></div>',
                    ].join(''),
                    options
                );

                modal.element
                    .find('.js-modal-confirm-cancel')
                    .on('click', function () {
                        oncancel();
                    })
                    .end()
                    .find('.uk-button-success')
                    .on('click', function () {
                        onInsert();
                    });

                modal.show();
            }
        });

        $('#blog_rename').click(function (e) {
            console.log($('#blogName'));
            var editviewRename = $('#Renameblog').html();

            $('.rvsb-design-property').hide();

            var UI = UIkit;

            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Rename') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        editviewRename +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Save') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('Cancel') +
                        '</button></div>',
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.element.find('#blogName').val(window.activeBlogname);

            modal.show();

            var onInsert = function () {
                var renameBlog = modal.element.find('#blogName').val().trim();

                axiosAPICategory
                    .axiosRenameCategory({
                        category_name: renameBlog,
                        slug_id: activeSlugID,
                    })
                    .then(response => {
                        response = response.data;

                        // Change current URL if URL use slug-prefix
                        var currentSlugURL = window.location.href;

                        if (currentSlugURL.match(activeSlug)) {
                            currentSlugURL = currentSlugURL.replace(
                                window.activeSlug,
                                response.data.slug_name
                            );

                            parent.activePageName = response.data.page_name;
                            CurrentSlugMySite = CurrentSlugMySite.replace(
                                window.activeSlug,
                                response.data.slug_name
                            );

                            window.history.pushState(
                                'data',
                                'Title',
                                currentSlugURL
                            );
                        }

                        axiosResponseUpdateBlog(response, renameBlog);

                        modal.hide();
                    })
                    .catch(err => {
                        console.inline.error({
                            target: modal.element.find('.warningblogName'),
                            text: err.data.errors.category_name,
                            delay: 5000,
                        });
                    });
            };

            oncancel = function () {
                modal.hide();
            };
        });
    });

    async function axiosResponseUpdateBlog(data, renameBlog) {
        const slug = parseInt(data.data.slug_id);
        const slug_prefix = data.data.slug_prefix;
        const slug_name = data.data.slug_name;

        // Update blog_categories
        var objCategory = wex.blog.blog_categories.find(
            ({ slug_id }) => slug_id == slug
        );

        objCategory.slug_name = slug_name;
        objCategory.text = renameBlog;
        objCategory.slug_prefix = slug_prefix;

        var objListCategory = wex.blog.blog_listscategory.find(
            ({ slug_id }) => slug_id == slug
        );

        objListCategory.slug_name = slug_name;
        objListCategory.text = renameBlog;
        objListCategory.slug_prefix = slug_prefix;
        objListCategory.url = `${slug_prefix}/${slug_name}/`;

        // END Update blog_categories

        /**
         * Update blog_lists
         */
        var objLists = wex.blog.blog_lists.filter(
            ({ category_slug_name }) => category_slug_name == parent.activeSlug
        );

        $.map(objLists, function (objPost, Key) {
            objPost.category_name = renameBlog;
            objPost.category_slug_name = slug_name;
            objPost.slug_prefix = `${slug_prefix}/${slug_name}`;
        });

        // END Update blog_lists

        /**
         * Update Child
         */

        var objChildListCategory = wex.blog.blog_listscategory.filter(
            ({ parent }) => parent == objListCategory.id
        );

        $.map(objChildListCategory, function (odjCategory, key) {
            odjCategory.slug_prefix = `${slug_prefix}/${slug_name}`;
        });

        // End Update Child
        if (slug == parent.currentSlugID) {
            parent.$('#cmsCurrent').text(renameBlog);
            window.history.pushState('data', 'Title', slug_name);
        }

        RVwys.rigthbar.isJstree.refreshBlog();
        console.pop.success({
            text: data.msg,
            delay: 5000,
        });
        $('.overlaypanel').remove();
    }

    function makeSlug(ModalElement) {
        console.log(parent.activePageName);
        console.log(window.activePageName);
        var newSlug;
        ModalElement.find('#pageName').val(parent.activePageName);
        parent.$('#pageUrl').val(parent.activeSlug);

        ModalElement.find('#pageName').keydown(function () {
            var BeforepageName = parent.$('#pageName').val().trim();

            ModalElement.find('#pageName').keyup(function () {
                var pageNameConvert = BeforepageName;
                pageNameConvert = pageNameConvert
                    .replace(/\W+(?!$)/g, '-')
                    .toLowerCase();
                pageNameConvert = pageNameConvert
                    .replace(/\W$/, '')
                    .toLowerCase();

                var pageUrl = parent.$('#pageUrl').val();
                if (
                    (BeforepageName === pageUrl) |
                    (pageNameConvert === pageUrl)
                ) {
                    var str = $(this).val();
                    str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
                    str = str.replace(/\W$/, '').toLowerCase();

                    parent.$('#pageUrl').val(str);
                }
            });
        });

        parent.$('#pageUrl').on('keyup', function (e) {
            var str = $(this).val().trim();
            str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
            str = str.replace(/ /g, '-').replace(/-+/g, '-').replace(/^-/g, '');
        });

        parent.$('#pageUrl').blur(function () {
            var ajaxSlug = '';
            var str = $(this).val().trim();
            str = str.replace(/\W$/, '').toLowerCase();
            if (str == '') {
                str = ModalElement.find('#pageName').val();
                str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
                str = str.replace(/\W$/, '').toLowerCase();
            }

            if ($(this).val() != parent.activeSlug) {
                RVwys.checkSlug(str, function (returnValue) {
                    ajaxSlug = returnValue;
                    parent.$('#pageUrl').val($.trim(ajaxSlug));
                });
            } else {
                $(this).val(str);
            }
        });

        ModalElement.find('#pageName').blur(function () {
            if ($(this).val() == '') {
                ModalElement.find('#pageName').val(parent.activePageName);
            }
            if (parent.$('#pageUrl').val() == '') {
                parent.$('#pageUrl').val(parent.activeSlug);
            }
        });
    }

    function getpricat(ElementModal) {
        var pricat = '';
        ElementModal.find('.spancatselect').each(function () {
            if ($(this).hasClass('oncategorypri') && $(this).html() != '') {
                pricat = $(this).attr('id');
            }
        });
        // if not select primary cat to get frist in cat make is primary
        if (pricat == '') {
            ElementModal.find('.spancatselect').each(function () {
                if ($(this).hasClass('oncategory') && $(this).html() != '') {
                    // alert($(this).attr("id"));
                    pricat = $(this).attr('id');
                    return false;
                }
            });
        }
        if (pricat == '') {
            pricat = ElementModal.find('.spancatselect').first().attr('id');
        }
        return pricat;
    }

    function getpostincat(ElementModal) {
        var postincat = [];
        ElementModal.find('.spancatselect').each(function () {
            if (
                ($(this).hasClass('oncategory') ||
                    $(this).hasClass('oncategorypri')) &&
                $(this).html() != ''
            ) {
                postincat.push($(this).attr('id'));
            }
        });
        // if not select category to push 1 to cat
        if (postincat.length === 0) {
            postincat.push(
                ElementModal.find('.spancatselect').first().attr('id')
            );
        }
        return postincat;
    }

    // ajax with callback
    function doAnAjax(url, data, type, callback) {
        $.ajax({
            url: url,
            data: data,
            cache: false,
            type: type,
            error: function (jqXHR, textStatus, errorThrown) {
                callback('error', jqXHR);
            },
            success: function (data) {
                callback('success', data);
            },
        });
    }

    function catmakePrimary(idname, ElementModal) {
        ElementModal.find('.spancatselect').each(function () {
            if (
                $(this).attr('id') != idname &&
                ($(this).hasClass('oncategory') ||
                    $(this).hasClass('oncategorypri'))
            ) {
                console.log('FN :: catmakePrimary :: Make Primary');

                $(this).html('Make Primary');
                $(this).removeClass('oncategorypri');
                $(this).addClass('oncategory');
            }

            if (
                $(this).attr('id') == idname &&
                ($(this).hasClass('oncategory') ||
                    $(this).hasClass('oncategorypri'))
            ) {
                console.log('FN ::  catmakePrimary :: Primary');

                $(this).html('Primary');
                $(this).removeClass('oncategory');
                $(this).addClass('oncategorypri');
                RVwys.CheckVisibility(true, idname, true, ElementModal);
            }
        });
    }

    function postCreateValidate(ElementModal) {
        var allcatname = [];
        ElementModal.find('#postCatSelect input').each(function () {
            allcatname.push($(this).attr('name'));
        });

        // alert(JSON.stringify(allcatname));
        ElementModal.find('#postCatName').removeClass(
            'uk-alert uk-alert-danger'
        );
        ElementModal.find('#postCatName_error').addClass('uk-hidden');
        if (ElementModal.find('#postCatName').val() == '') {
            ElementModal.find('#postCatName').addClass(
                'uk-alert uk-alert-danger'
            );
            ElementModal.find('#postCatName_error').html(
                'Oh! You forget to add name for the new category!'
            );
            ElementModal.find('#postCatName_error').removeClass('uk-hidden');
            return false;
        }

        console.log('====================================');
        console.log(allcatname);
        console.log('====================================');
        // if (
        //     $.inArray(ElementModal.find('#postCatName').val(), allcatname) !==
        //     -1
        // ) {
        //     ElementModal.find('#postCatName').addClass(
        //         'uk-alert uk-alert-danger'
        //     );
        //     ElementModal.find('#postCatName_error').html(
        //         'Category name duplicated!'
        //     );
        //     ElementModal.find('#postCatName_error').removeClass('uk-hidden');
        //     return false;
        // }
        return true;
    }

    function addcategory(ElementModal) {
        var catname = ElementModal.find('#postCatName').val();
        var parent = ElementModal.find('#postCatParent option:selected').val();

        axiosAPICategory
            .axiosSaveCategory({
                catname: catname,
                parent: parent,
            })
            .then(response => {
                var data = response.data;
                var htmlchkbox = getCategoryCheckbox(data.cat);
                var htmlselbox = getCategoryselectbox(data.cat);
                ElementModal.find('#postCatSelect').html(htmlchkbox);
                ElementModal.find('#postCatParent').html(htmlselbox);

                eventpost(ElementModal);

                var wexcatList = {
                    id: 'category' + data.id,
                    parent: wex.blog.blog_listscategory[0].id,
                    slug_id: data.slug_id,
                    slug_name: data.slug_name,
                    slug_prefix: 'blog',
                    text: data.lastCat,
                    type: 'category',
                };
                wex.blog.blog_listscategory.push(wexcatList);

                var type = data.parent_id == '0' ? '#' : data.parent_id;

                var wexCat = {
                    id: data.id,
                    category_name: data.lastCat,
                    parent: type,
                    parent_id: parseInt(data.parent_id),
                    text: data.lastCat,
                };

                wex.blog.blog_categories.push(wexCat);

                ElementModal.find('#groupCreateCat').addClass('uk-hidden');
                ElementModal.find('#postCatName').val('');
            })
            .catch(err => {
                const msgError = err.data.errors.catname;
                ElementModal.find('#postCatName_error')
                    .html(msgError)
                    .removeClass('uk-hidden');
            });
    }

    function getCategoryCheckbox(catlist) {
        // for checkbox cat
        var htmlchkbox = '';
        $.each(catlist, function (i, cat) {
            // alert(cat.category_name);
            htmlchkbox =
                htmlchkbox +
                '<li><input id="" value="' +
                cat.id +
                '" name="' +
                cat.category_name +
                '" type="checkbox" class="catSelect" visibility="' +
                cat.visibility +
                '">' +
                ' ' +
                '<span class="text-ellipsis">' +
                cat.category_name +
                '</span>' +
                '  <i class="icon-visibility category-' +
                cat.visibility_icon +
                '"></i><span class="poststatus">(' +
                cat.role_name +
                ') </span>' +
                ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                cat.id +
                '" id="' +
                cat.id +
                '"></button>';
            $.each(cat.subcategories, function (i, subcat1) {
                console.log('-------subcat1-------');
                console.log(subcat1);
                // alert(subcat1.category_name);
                htmlchkbox =
                    htmlchkbox +
                    '<ul class="list-tree1"><li><input id="" value="' +
                    subcat1.id +
                    '" name="' +
                    subcat1.category_name +
                    '" type="checkbox" class="catSelect" visibility="' +
                    subcat1.visibility +
                    '">' +
                    ' ' +
                    '<span class="text-ellipsis">' +
                    subcat1.category_name +
                    '</span>' +
                    ' <i class="icon-visibility category-' +
                    subcat1.visibility_icon +
                    '"></i><span class="poststatus" >(' +
                    subcat1.role_name +
                    ') </span>' +
                    ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                    subcat1.id +
                    '" id="' +
                    subcat1.id +
                    '"></button>';
                $.each(subcat1.subcategories, function (i, subcat2) {
                    console.log('-------subcat2-------');
                    console.log(subcat2);
                    // alert(subcat2.category_name);
                    htmlchkbox =
                        htmlchkbox +
                        '<ul class="list-tree2"><li><input id="" value="' +
                        subcat2.id +
                        '" name="' +
                        subcat2.category_name +
                        '" type="checkbox" class="catSelect" visibility="' +
                        subcat2.visibility +
                        '">' +
                        ' ' +
                        '<span class="text-ellipsis">' +
                        subcat2.category_name +
                        '</span>' +
                        ' <i class="icon-visibility category-' +
                        subcat2.visibility_icon +
                        '"></i><span class="poststatus">(' +
                        subcat2.role_name +
                        ') </span>' +
                        ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                        subcat2.id +
                        '" id="' +
                        subcat2.id +
                        '"></button>';
                    $.each(subcat2.subcategories, function (i, subcat3) {
                        console.log('-------subcat3-------');
                        console.log(subcat3);
                        // alert(subcat3.category_name);
                        htmlchkbox =
                            htmlchkbox +
                            '<ul class="list-tree3"><li><input id="" value="' +
                            subcat3.id +
                            '" name="' +
                            subcat3.category_name +
                            '" type="checkbox" class="catSelect" visibility="' +
                            subcat3.visibility +
                            '">' +
                            ' ' +
                            '<span class="text-ellipsis">' +
                            subcat3.category_name +
                            '</span>' +
                            ' <i class="icon-visibility category-' +
                            subcat3.visibility_icon +
                            '"></i><span class="poststatus">(' +
                            subcat3.role_name +
                            ') </span>' +
                            ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                            subcat3.id +
                            '" id="' +
                            subcat3.id +
                            '"></button> </li></ul>';
                    });
                    htmlchkbox = htmlchkbox + '</li></ul>';
                });
                htmlchkbox = htmlchkbox + '</li></ul>';
            });
            htmlchkbox = htmlchkbox + '</li>';
        });
        return htmlchkbox;
    }

    function getCategoryselectbox(catlist) {
        // for parent cat
        var htmlselbox;
        $.each(catlist, function (i, cat) {
            // alert(cat.category_name);
            htmlselbox += `<option value="${cat.id}">${cat.category_name}</option>`;
            $.each(cat.subcategories, function (i, subcat1) {
                // alert(subcat1.category_name);
                htmlselbox += `<option value="${subcat1.id}">| - ${subcat1.category_name}</option>`;
                $.each(subcat1.subcategories, function (i, subcat2) {
                    // alert(subcat2.category_name);
                    htmlselbox += `<option value="${subcat2.id}">| --- ${subcat2.category_name}</option>`;
                    $.each(subcat2.subcategories, function (i, subcat3) {
                        // alert(subcat3.category_name)
                        htmlselbox += `<option value="${subcat3.id}" disabled>| ------ ${subcat3.category_name}</option>`;
                    });
                });
            });
        });
        return htmlselbox;
    }

    function eventpost(ElementModal) {
        // select catagory
        ElementModal.find('.catSelect').on('change', function () {
            console.log('isCheck ==> ' + this.checked);
            var btnPri = ElementModal.find(
                '.catSelect[value=' + $(this).val() + ']'
            )
                .closest('li')
                .find('.spancatselect')
                .first();
            var isCheck = this.checked;
            var isPrimary = btnPri.hasClass('oncategorypri');
            if (isCheck) {
                // Check has Primary
                if (
                    !ElementModal.find('.spancatselect').hasClass(
                        'oncategorypri'
                    )
                ) {
                    btnPri.text('Primary');
                    btnPri.removeClass('oncategory');
                    btnPri.addClass('oncategorypri');

                    RVwys.CheckVisibility(
                        isCheck,
                        $(this).val(),
                        true,
                        ElementModal
                    );
                } else {
                    btnPri.text('Make Primary');
                    btnPri.removeClass('oncategorypri');
                    btnPri.addClass('oncategory');
                }
            } else {
                btnPri.text('');
                btnPri.removeClass('oncategory');
                btnPri.removeClass('oncategorypri');

                if (isPrimary) {
                    RVwys.CheckVisibility(
                        isCheck,
                        $(this).val(),
                        true,
                        ElementModal
                    );
                    // set new primary by first select
                    ElementModal.find('.spancatselect').each(function () {
                        if ($(this).hasClass('oncategory')) {
                            $(this).addClass('oncategorypri');
                            $(this).html('Primary');
                            var id = $(this).attr('id');
                            RVwys.CheckVisibility(true, id, true, ElementModal);
                        }
                    });
                }
            }

            // catselect(this.checked,$(this).val(),ElementModal);
        });
        // take off General check default
        // $('#postCatSelect').find('input.catSelect[name=General]').prop('checked',
        // true);
        // $(".catSelect").trigger( "change" );

        // make primary
        ElementModal.find('.spancatselect').on('click', function () {
            if (!$(this).hasClass('oncategorypri')) {
                catmakePrimary($(this).attr('id'), ElementModal);
            }
        });

        // add cat box
        ElementModal.find('#postCatAdd').on('click', function () {
            ElementModal.find('#groupCreateCat').removeClass('uk-hidden');
        });
    }

    RVwys.CheckVisibility = function (
        Checked,
        inputID,
        isPrimary,
        ElementModal
    ) {
        console.log(
            '//////////////////////////////////////////////////////////'
        );
        console.log('FN::RVwys.CheckVisibility');
        console.log(Checked + ' <------> ' + inputID);

        var visibility = ElementModal.find(
            '.catSelect[value=' + inputID + ']'
        ).attr('visibility');

        if (Checked) {
            console.log('isPrimary ---> ' + isPrimary);
            console.log('visibility ---> ' + visibility);

            if (visibility == '1') {
                console.log('visibility 1');

                var oThis = ElementModal.find('.catSelect[visibility=0]');

                oThis.prop({
                    disabled: true,
                });
                oThis.prop({
                    checked: false,
                });

                if (isPrimary) {
                    var catselect = oThis.closest('li').find('.spancatselect');

                    $.each(catselect, function () {
                        var ckInput = $(this)
                            .closest('li')
                            .find('input')
                            .first();
                        if (!ckInput.prop('checked')) {
                            $(this).text('');
                            $(this)
                                .removeClass('oncategory')
                                .removeClass('oncategorypri');
                        }
                    });
                }
            } else if (visibility == '2') {
                console.log('visibility 2');
                oThis = ElementModal.find('.catSelect[visibility!=2]');
                oThis.prop({
                    disabled: true,
                });
                oThis.prop({
                    checked: false,
                });

                if (isPrimary) {
                    catselect = oThis.closest('li').find('.spancatselect');
                    $.each(catselect, function () {
                        var ckInput = $(this)
                            .closest('li')
                            .find('input')
                            .first();
                        if (!ckInput.prop('checked')) {
                            $(this).text('');
                            $(this)
                                .removeClass('oncategory')
                                .removeClass('oncategorypri');
                        }
                    });
                }
            } else {
                console.log('visibility 0');
                ElementModal.find('.catSelect[visibility]').prop({
                    disabled: false,
                });
            }
        } else {
            ElementModal.find(
                '.catSelect[visibility!=' + visibility + ']'
            ).prop({
                disabled: false,
            });
        }
    };
    RVwys.addPostModal = function () {
        var editviewAddPost = $('#editviewAddPost').html();
        var UI = UIkit;
        var modal = UI.modal.dialog(
            [
                `<div class="wys-rvcontent">
                <div class="uk-margin uk-modal-header">
                    <h2>${rvLang('Add Post')}</h2>
                    <span class="uk-modal-close uk-icon-close"></span>
                </div>
                    <div class="uk-margin uk-modal-content">${editviewAddPost}</div>
                <div class="uk-modal-footer uk-text-left clear">
                    <button class="uk-button uk-button-primary uk-button-success-addpost  js-modal-confirm">
                        ${rvLang('Save')}
                    </button>
                    <button class="uk-button js-modal-confirm-cancel-addpost">
                        ${rvLang('Cancel')}
                    </button>
                </div>
            </div>`,
            ].join(''),
            {
                bgclose: false,
                keyboard: false,
                modal: false,
            }
        );

        modal.element
            .find('.js-modal-confirm-cancel-addpost')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success-addpost')
            .on('click', function () {
                onInsert();
            });
        modal.show();

        var onInsert = function () {
            var postname = modal.element.find('#postName').val();
            var inCategory = [];
            inCategory = getpostincat(modal.element);
            var pricat = getpricat(modal.element);
            axiosAPIBlog
                .axiosBlogCreatePost({
                    post_name: postname,
                    save_img: 1,
                    incat: inCategory,
                    pricat: pricat,
                })
                .then(response => {
                    var url = '/' + response.data.url;
                    window.location.href = parent.wex.url.WYS_SHOW_URL + url;

                    modal.hide();
                })
                .catch(err => {
                    var msg = err.data.errors.post_name[0];

                    console.inline.error({
                        target: modal.element.find('#postName_error'),
                        title: Error,
                        text: msg,
                        delay: 5000,
                    });
                });
        };

        var oncancel = function () {
            modal.hide();
        };

        // query all category postCatSelect
        var htmlchkbox = '';
        var htmlselbox = '';

        axiosAPICategory
            .axiosGetCategory()
            .then(response => {
                var data = response.data;
                htmlchkbox = getCategoryCheckbox(data.cat);
                htmlselbox = getCategoryselectbox(data.cat);
                modal.element.find('#postCatSelect').html(htmlchkbox);
                modal.element.find('#postCatParent').html(htmlselbox);

                eventpost(modal.element);
            })
            .catch(err => {
                console.pop.error({
                    text: `Status Code: ${err.status} ( ${err.statusText} )`,
                    delay: 5000,
                });
            });

        // add cat
        modal.element.find('#postCreateCat').on('click', function (e) {
            var valid = postCreateValidate(modal.element);
            // alert(valid);
            if (valid) {
                addcategory(modal.element);
            }
        });
    };

    RVwys.addPageModal = function () {
        var fb = $('#frameBody').get(0).contentWindow;
        var editviewAddPage = $('#editviewAddPage').html();

        const pageSetting = $('.pageSetting') ?? fb.$('.pageSetting');
        pageSetting.hide();

        const barPage = $('.bar-page') ?? fb.$('.bar-page');
        barPage.addClass('bar-category-hidden');

        const barRight = $('.bar-right') ?? fb.$('.bar-right');
        barRight.addClass('bar-category-hidden');

        var overlaypanel = $(
            `<div class="overlaypanel">
                <img class="loading" src="${parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
            </div>`
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        var UI = parent.UIkit;
        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var onInsert = function () {
            // Add page and add menu
            var isShow = modal.element.find('#showOnMenu').is(':checked');
            if (isShow) {
                var showMenu = 1;
            } else {
                showMenu = 0;
            }
            $('#warningPageName').hide();

            var overlaypanel = $(
                `<div class="overlaypanel">
                    <img class="loading" src="${parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
                </div>`
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });
            $('body').append(overlaypanel);
            var page_name = modal.element.find('#pageName').val();

            axiosAPI
                .axiosAddPage({ page_name: page_name, showMenu: showMenu })
                .then(result => {
                    setTimeout(function () {
                        window.location.href = `${parent.wex.url.WYS_SHOW_URL}/${result.data.new_slug}`;
                    }, 1000);
                    modal.hide();
                })
                .catch(err => {
                    parent.$('.overlaypanel').remove();

                    var err_page = err.data.errors.page_name;
                    modal.element.find('#msgerrAddpage').html('');
                    $.each(err_page, function (k, v) {
                        // modal.element.find();
                        console.inline.error({
                            target: modal.element.find('#msgerrAddpage'),
                            text: v,
                            delay: 5000,
                        });
                    });
                });
        };

        var oncancel = function () {
            modal.hide();
        };

        var modal = UI.modal.dialog(
            [
                `<div class="wys-rvcontent">
                <div class="uk-margin uk-modal-header">
                    <h2>${rvLang('Add Page')}</h2>
                    <span class="uk-modal-close uk-icon-close"></span>
                </div>
                <div class="uk-margin uk-modal-content">${editviewAddPage}</div>
                <div class="uk-modal-footer uk-text-left clear">
                    <br>
                    <button class="uk-button uk-button-success  js-modal-confirm">
                        ${rvLang('Save')}
                    </button>
                    <button class="uk-button js-modal-confirm-cancel">
                        ${rvLang('Cancel')}
                    </button>
                </div>
            </div>`,
            ].join(''),
            options
        );

        modal.element
            .find('.js-modal-confirm-cancel')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success')
            .on('click', function () {
                onInsert();
            });
        modal.show();
    };

    RVwys.SaveBacktoTop = function (oThis) {
        var backtotop = oThis;
        axiosAPI
            .axiosSaveSettingBacktotop({ backtotop: backtotop })
            .then(result => {
                $('#frameBody')
                    .get(0)
                    .contentWindow.$('#back-top')
                    .attr('backtotop', backtotop);
            });
    };

    // fn::JStree
    RVwys.rigthbar.isJstree.Eventjstree = function ($this) {
        var isThis = $this.closest('#listblog').length
            ? '.postSetting '
            : '.pageSetting';
        var isSetting = $this.closest('#listblog').length
            ? 'postSetting'
            : 'pageSetting';

        console.log('$this: ', $this);
        var isPublic = $this.attr('is-published') == 1 ? true : false;

        var parentPubilc =
            $this.parent().closest('li').attr('is-published') == 1
                ? true
                : false;

        parentPubilc;

        var getJstree = !$this.closest('div').jstree(true)
            ? parent.$('#' + $this.closest('div').attr('id')).jstree(true)
            : $this.closest('div').jstree(true);
        var isChild = getJstree.get_node($this.attr('id')).children.length > 0;
        var isCategory = parent.activeType == 'category' ? true : false;

        var parentPubilc = true;
        if (isChild) {
            var $parentNode = $this.parent().closest('li');
            console.log('$parentNode: ', $parentNode);

            $this.parent().closest('li').attr('is-published') == 1
                ? true
                : false;
        }

        var isHomepage =
            $this.attr('is-homepage') == 1 ||
            $this.attr('is-homepage') === 'true'
                ? true
                : false;

        console.log('*******************************************');
        console.log('isChild - ', isChild);
        console.log('parentPubilc - ', parentPubilc);
        console.log('isPublic - ', isPublic);
        console.log('isHomepage: ', isHomepage);

        if (parentPubilc) {
            parent.$(isThis + ' #setHide').toggle(isPublic);
            parent.$(isThis + ' #unsetHide').toggle(!isPublic);
        }

        parent.$(isThis + ' #deletePage').toggle(!isHomepage);
        parent.$(isThis + ' #setHomePage').toggle(!isHomepage);

        if (isHomepage) {
            parent.$(isThis + ' #setHide').hide();
        } else {
            parent.$(isThis + ' #setHomePage').toggle(isPublic);
        }

        if ($this.attr('slug-id') == parent.currentSlugID) {
            parent.$(isThis + ' #deletePage').hide();
        }

        if (isChild) {
            parent.$(isThis + ' #deletePage').toggle(!isHomepage);
        }

        // console.log($this.attr('page-name'));
        $('.rvsb-design-property').hide();
        parent.$(isThis + ' #titlePage').text(parent.activePageName);
        parent.$('.' + isSetting).show();
        var positionsetting = $this.position();

        var Maxh = screen.height - positionsetting.top;
        if (Maxh < 350) {
            parent.$('.' + isSetting).css({
                right: '200px',
                top: '410',
            });
        } else {
            parent.$('.' + isSetting).css({
                right: '200px',
                top: positionsetting.top - 5,
            });
        }
        // console.log('Top'+positionSettingPage.top+'- Height'+screen.height+'=');
        // console.log(screen.height-positionSettingPage.top)
    };

    RVwys.rigthbar.isJstree.Callbackoption = function (
        data,
        typeoption,
        typebar = 'page'
    ) {
        var element =
            $('#' + parent.eleActive).length > 0
                ? $('#' + parent.eleActive)
                : parent.$('#' + parent.eleActive);

        var oLi = $('.liListPage[slug-id=' + parent.activeSlugID + ']');

        var isType = element.closest('div').attr('id');

        var otOpt = {
            setHide: {},
            unsetHide: {},
        };

        otOpt.setHide.optPage = 0;
        otOpt.setHide.status =
            typebar == 'page' ? 'page-normal-hide' : 'post-normal-hide';
        otOpt.setHide.sPage = '<i class="uk-icon-edit"></i><span>Draft</span>';

        otOpt.unsetHide.optPage = 1;
        otOpt.unsetHide.status = typebar == 'page' ? typebar : 'post';
        otOpt.unsetHide.sPage = '<i class="uk-icon-globe"><span>Public</span>';

        var typepage = {
            page: {},
            blog: {},
        };

        typepage.page.type = 'page';

        typepage.page.Json = 'page_tree';
        typepage.page.recently = 'page_recently';

        typepage.blog.type = 'blog';
        typepage.blog.Json = 'blog_lists';
        typepage.blog.jsonCat = 'blog_listscategory';
        typepage.blog.recently = 'blog_recently';

        var beforeSlug = parent.activeSlug;
        var afterSlug = data.data.page_name;
        var isData = data.data;
        var isSlugID = isData.slug_id;

        var isEle = element.find('[slug-id=' + isData.slug_id + ']');
        var isEleID = isEle.attr('id');
        var isEletype = isEle.attr['page-type'];
        var isEleslugID = parseInt(isEle.attr['slug-id']);
        var isThis = element.find(
            '#' + isEleID + '[page-type=' + isEletype + ']'
        );
        var IndexKey = element.find('#' + isEleID).attr('indexkey');
        var isType = element.closest('div').attr('id');
        var pageJson = isType.match(/^list(.*)/im)[1].toLowerCase();

        var indexRecent = $.map(
            parent.wex[typebar][typepage[typebar].recently],
            function (obj) {
                return obj.text;
            }
        ).indexOf(parent.activePageName);

        var isEleRecent = typebar == 'page' ? 'RecentPage' : 'RecentPost';

        switch (typeoption) {
            case 'setHomePage':
                var objpage = {
                    0: 'page_onmenu',
                    1: 'page_internal',
                };
                var visibilityIcon =
                    parent.wex[typebar][typepage[typebar].Json][IndexKey].type;

                $.each(objpage, function (k, objpage) {
                    var indexHome = $.map(
                        parent.wex[typebar][objpage],
                        function (obj, index) {
                            return obj.is_homepage;
                        }
                    ).indexOf(1);

                    if (indexHome != -1) {
                        parent.wex[typebar][objpage][indexHome].is_homepage = 0;
                        parent.wex[typebar][objpage][
                            indexHome
                        ].type = visibilityIcon;

                        const isSlug =
                            parent.wex[typebar][objpage][indexHome].slug_id;
                        if (parent.currentSlugID == isSlug) {
                            const classIcon = parent
                                .$('#CurrenttypeIcon')
                                .attr('class')
                                .match(/icon\-visibility\s(.*)/)[1];

                            visibilityIcon =
                                visibilityIcon == 'restricted'
                                    ? 'specific'
                                    : visibilityIcon;

                            visibilityIcon =
                                visibilityIcon == 'internal-member'
                                    ? 'member'
                                    : visibilityIcon;

                            const changIcon =
                                parent.wex.iconvisibility[typebar].parent[
                                    visibilityIcon
                                ];

                            parent
                                .$('#CurrenttypeIcon')
                                .removeClass(`${classIcon}`)
                                .addClass(`${changIcon}`);
                        }
                    } else {
                        parent.wex[typebar][typepage[typebar].Json][
                            IndexKey
                        ].is_homepage = 1;

                        parent.wex[typebar][typepage[typebar].Json][
                            IndexKey
                        ].type = 'home-normal';

                        if (isData.slug_id == parent.currentSlugID) {
                            const classIcon = parent
                                .$('#CurrenttypeIcon')
                                .attr('class')
                                .match(/icon\-visibility\s(.*)/)[1];

                            visibilityIcon =
                                visibilityIcon == 'restricted'
                                    ? 'specific'
                                    : visibilityIcon;

                            visibilityIcon =
                                visibilityIcon == 'internal-member'
                                    ? 'member'
                                    : visibilityIcon;

                            const changIcon =
                                parent.wex.iconvisibility.home[visibilityIcon];

                            parent
                                .$('#CurrenttypeIcon')
                                .removeClass(`${classIcon}`)
                                .addClass(`${changIcon}`);
                        }
                    }
                });

                break;

            case 'deletePage':
                var fb = $('#frameBody').get(0).contentWindow;
                var isParent =
                    parent.wex[typebar][typepage[typebar].Json][IndexKey]
                        .parent;

                parent.wex[typebar][typepage[typebar].Json].splice(IndexKey, 1);
                parent.wex[typebar][typepage[typebar].recently].splice(
                    indexRecent,
                    1
                );

                if (fb.$(`#selected_navigator [slug-id="${isData.slug_id}"]`)) {
                    fb.$(
                        `#selected_navigator [slug-id="${isData.slug_id}"]`
                    ).remove();
                }

                if (typebar == 'blog') {
                    var lengthPost = $.grep(
                        parent.wex[typebar][typepage[typebar].Json],
                        function (k, v) {
                            return k.parent == isParent;
                        }
                    ).length;

                    if (!lengthPost) {
                        $.grep(
                            parent.wex[typebar][typepage[typebar].jsonCat],
                            function (k, v) {
                                if (k.id == isParent) {
                                    k.haveChild = false;
                                }
                            }
                        );
                    }
                }

                parent.$('#' + isEleRecent).jstree(true).settings.core.data =
                    parent.wex[typebar][typepage[typebar].recently];

                parent
                    .$('#' + isEleRecent)
                    .jstree(true)
                    .refresh();

                break;

            case 'rename':
                // update wex
                var wexData =
                    typebar == 'page'
                        ? parent.wex.page.page_tree
                        : wex.blog.blog_lists;
                console.log('wexData: ', wexData);
                var objUpdate = wexData.find(
                    ({ slug_id }) => slug_id == isSlugID
                );
                var { slug_name, page_name, slug_id, url } = isData;
                objUpdate.slug_name = slug_name;
                objUpdate.page_name = page_name;
                objUpdate.text = page_name;

                if (['post', 'blog'].includes(typebar)) {
                    objUpdate.post_name = page_name;
                }

                if (indexRecent >= 0) {
                    parent.wex[typebar][typepage[typebar].recently][
                        indexRecent
                    ].text = isData.page_name;
                    parent
                        .$('#' + isEleRecent)
                        .jstree(true).settings.core.data =
                        parent.wex[typebar][typepage[typebar].recently];
                }

                parent.$('#' + isEleRecent).jstree('refresh');

                if (isData.slug_id == parent.currentSlugID) {
                    parent.$('#cmsCurrent').text(isData.page_name);
                    window.history.pushState('data', 'Title', isData.url);
                    CurrentSlugMySite = CurrentSlugMySite.replace(
                        window.activeSlug,
                        isData.slug_name
                    );
                    window.activeSlug = isData.slug_name;
                    parent.activePageName = isData.page_name;
                }

                if (isData.changed_menutitle) {
                    RVwys.rigthbar.isJstree.updatemenu(beforeSlug, isData);
                }

                break;
            default:
                // Final else

                break;
        }

        $('.rvsb-design-property').hide();

        // TODO: REFRESH DATA AFTER CHANGE - WARITHAR @Netway-Warithar
        var isData;
        switch (typebar) {
            case 'blog':
            case 'post':
                RVwys.rigthbar.isJstree.refreshBlog();
                break;

            case 'page':
                RVwys.rigthbar.isJstree.refreshPage();
                break;

            default:
                isData = parent.wex[typebar][typepage[typebar].Json];
                RVwys.rigthbar.isJstree.refresh(
                    parent.$('#' + isType),
                    isData,
                    typebar
                );
                break;
        }
    };
    RVwys.rigthbar.isJstree.Callbackoption.duplicate = function (resData) {
        var type = activePageType;
        var typeData = wex[type].page_tree ?? wex[type].blog_lists;
        var typeMatch = activePageType == 'page' ? 'page' : 'post';
        var index = typeData.filter(item => item.type.match(typeMatch));

        typeData.splice(index.length, 0, resData);

        var thisActive = type.charAt(0).toUpperCase() + type.slice(1);
        var thisRefresh = `refresh${thisActive}`;
        RVwys.rigthbar.isJstree[thisRefresh]();

        parent.$('.overlaypanel').remove();
    };

    RVwys.rigthbar.isJstree.Callbackoption.Hide = function (dataObj) {
        var { slug_id } = dataObj;

        if (slug_id == parent.currentSlugID) {
            parent.$('.current-optionPage').attr('is-pulbic', 0);
            parent
                .$('#CurrentType')
                .closest('.sprite-icon-visibility')
                .css('opacity', '0.5');
        }

        $(`#selected_navigator li[menu-slug='${parent.activeSlug}']
        [slug-id='${slug_id}'] a`)
            .first()
            .toggleClass('draftmenu', true);
        var wexData =
            activePageType == 'page' ? wex.page.page_tree : wex.blog.blog_lists;
        var getSlug_id = slug_id;
        var activeData = wexData.find(({ slug_id }) => slug_id == getSlug_id);

        activeData.is_published = 0;
        activeData.type = `${activeData.type}-hide`;
        activeData.statusIcon = `${activeData.statusIcon}-hide`;

        RVwys.rigthbar.isJstree.recursiveChild({
            wexData,
            slug_id,
            type: 'hide',
        });
    };

    RVwys.rigthbar.isJstree.Callbackoption.unHide = function (dataObj) {
        var { slug_id } = dataObj;

        if (slug_id == parent.currentSlugID) {
            parent.$('.current-optionPage').attr('is-pulbic', 1);

            parent
                .$('#CurrentType')
                .closest('.sprite-icon-visibility')
                .removeAttr('style');
        }

        $(`#selected_navigator li[menu-slug='${parent.activeSlug}']
        [slug-id='${slug_id}'] a`)
            .first()
            .toggleClass('draftmenu', true);

        var wexData =
            activePageType == 'page' ? wex.page.page_tree : wex.blog.blog_lists;
        var getSlug_id = slug_id;
        var activeData = wexData.find(({ slug_id }) => slug_id == getSlug_id);

        activeData.is_published = 1;
        activeData.type = activeData.type.replace('-hide', '');
        activeData.statusIcon = activeData.statusIcon.replace('-hide', '');

        RVwys.rigthbar.isJstree.recursiveChild({
            wexData,
            slug_id,
            type: 'unhide',
        });
    };

    RVwys.rigthbar.isJstree.recursiveChild = function (data) {
        var { slug_id, type, wexData } = data;

        var pagesChild = wexData.filter(({ parent }) => parent == slug_id);
        var haveChild = wexData.filter(({ parent }) => parent == pagesChild.id);
        console.log('pagesChild: ', pagesChild);

        if (pagesChild.length) {
            $.map(pagesChild, function (valueInObject) {
                if (type == 'hide') {
                    valueInObject.is_published = 0;
                    valueInObject.type = `${valueInObject.type}-hide`;
                    valueInObject.statusIcon = `${valueInObject.statusIcon}-hide`;
                } else {
                    valueInObject.is_published = 1;
                    valueInObject.type = valueInObject.type.replace(
                        '-hide',
                        ''
                    );
                    valueInObject.statusIcon = valueInObject.statusIcon.replace(
                        '-hide',
                        ''
                    );
                }
            });

            if (haveChild.length) {
                var { slug_id } = haveChild;
                RVwys.rigthbar.isJstree.recursiveChild({ slug_id, type });
            }
        }

        var thisRefresh = `refresh${activePageType
            .charAt(0)
            .toUpperCase()}${activePageType.slice(1)}`;

        RVwys.rigthbar.isJstree[thisRefresh]();
    };

    RVwys.rigthbar.isJstree.createJSTrees = async function (
        $element,
        dataFromWex,
        typeAll
    ) {
        const { type, iconType } = typeAll;
        const newIconType = {
            ...customIconJStree.JStreeTypeIconHome(),
            ...iconType,
        };

        dataFromWex = await BuildAttrIsJstreeSetJstree(type, dataFromWex);

        $element.prev().find('span').text(dataFromWex.length);

        // RVwys.rigthbar.isJstree[type].SetJstree($element,data);
        // RVwys.rigthbar.isJstree.refresh($element,data,type);

        $element.jstree({
            core: {
                worker: true,
                data: dataFromWex,
            },
            types: newIconType,
            search: {
                case_insensitive: true,
                show_only_matches: true,
                // 'search_leaves_only':true
            },
            plugins: ['types', 'search', 'massload'],
        });

        $element.on('ready.jstree', function (event, data) {});

        $element.on('hover_node.jstree', function (e, data) {
            $(this).find('.icon-control').remove();
            var thisNode = $(this).find(`[id="${data.node.id}"]`);
            var nodeData = data.node;

            if (
                RVwys.rigthbar.isJstree?.[type] &&
                !nodeData.type.match('system')
            ) {
                RVwys.rigthbar.isJstree[type]?.CreateOption?.(
                    thisNode,
                    nodeData
                );
            }
        });

        $element.on('dehover_node.jstree', function () {
            console.log('dehover_node.jstree');
        });

        $element.on('open_node.jstree', function () {
            console.log('open_node.jstree');
        });

        $element.on('select_node.jstree', function (e, data) {
            var href = data.node.a_attr.href;
            parent.window.location.href = href;
        });

        $element
            .on('search.jstree', function (nodes, str) {
                if (str.nodes.length === 0) {
                    // element.jstree(true).hide_all();
                }
            })
            .on('clear_search.jstree', function (e) {
                // element.jstree(true).show_all();
            });
    };

    RVwys.rigthbar.isJstree.page.CreateOption = function (thisNode, nodeData) {
        console.log('nodeData: ', nodeData);

        if (!thisNode.is('[page-type="externalmenu"]')) {
            var iconOption = $(
                `<button class="icon-control">
                    <i class="uk-icon-small uk-icon-ellipsis-v editPage pull-right ${nodeData.id}" ></i>
                </button>`
            );

            if (thisNode.find('ul').length > 0) {
                iconOption.insertBefore(thisNode.find('ul').first());
            } else {
                thisNode.append(iconOption);
            }

            iconOption.click(function (e) {
                var type = $(this)
                    .closest('.dd')
                    .attr('id')
                    .match(/^sortable-(.*)/)[1];
                var oThis = $(this).closest('li');
                parent.activePageID = oThis.attr('page-id');
                parent.activePageName = oThis.attr('page-name');
                parent.activeSlug = oThis.attr('slug-name');
                window.activeSlugID = oThis.attr('slug-id');
                window.activePageType = type;
                parent.activeType = oThis.attr('page-type');

                parent.activeId = oThis.attr('id');
                parent.eleActive = $(e.target).closest('div')[0].id;

                console.log('parent.activePageType : ' + window.activePageType);
                RVwys.rigthbar.isJstree.Eventjstree(oThis);
            });
        }
    };

    RVwys.rigthbar.isJstree.blog.CreateOption = function (thisNode, nodeData) {
        var iconOptionPost = $(`<button class="icon-control">
        <i class="uk-icon-small uk-icon-ellipsis-v editPage pull-right ${nodeData.id}"></i>
        </button>`);

        var iconOptionCategory = $(`<button class="icon-control">
        <i class="uk-icon-small uk-icon-ellipsis-v editCate pull-right ${nodeData.id}"></i>
        </button>`);

        var defaultฺBlogID = parent.wex.blog.blog_listscategory[0].id;

        if (thisNode.hasClass('blog_cate')) {
            if (thisNode.find('ul').length > 0) {
                iconOptionCategory.insertBefore(thisNode.find('ul').first());
            } else {
                thisNode.prepend(iconOptionCategory);
            }
        } else {
            thisNode.prepend(iconOptionPost);
        }

        iconOptionPost.click(function (e) {
            console.log('%c Click Post', 'background-color:yellow');

            var oThis = $(this).closest('li');

            window.activePageType = 'blog';
            parent.activePageID = oThis.attr('post-id');
            parent.activePageName = oThis.attr('post-name');
            parent.activeSlug = oThis.attr('slug-name');
            window.activeSlugID = oThis.attr('slug-id');
            parent.activeType = oThis.attr('post-type');

            parent.activeId = oThis.attr('id');
            parent.eleActive = $(e.target).closest('div')[0].id;
            RVwys.rigthbar.isJstree.Eventjstree(oThis);

            // console.log('type '+parent.activePageType);
        });

        iconOptionCategory.click(function (e) {
            console.log('Click Category');
            var oThis = $(this).closest('li');
            var Id = oThis.attr('category-id').match(/^category(.*)/)
                ? oThis.attr('category-id').match(/^category(.*)/)[1]
                : oThis.attr('category-id');
            window.activePageType = 'blog';
            window.activeBlogId = Id;
            window.activeBlogname = oThis.attr('category-text');
            parent.activeSlug = oThis.attr('slug-name');
            window.activeIndexKey = oThis.attr('indexkey');
            window.activeSlugID = oThis.attr('slug-id');
            parent.eleActive = $(e.target).closest('div')[0].id;
            window.blogindex = activeIndexKey == '0' ? true : false;

            RVwys.rigthbar.isJstree.EventBlog(oThis);
        });
    };

    RVwys.rigthbar.isJstree.refresh = async function (element, jsonData, type) {
        console.log('START FUNCTION: RVwys.rigthbar.isJstree.refresh');
        console.log('element: ', element);
        console.log('jsonData: ', jsonData);
        jsonData = await BuildAttrIsJstreeSetJstree(type, jsonData);
        if (element.jstree(true).settings?.core?.data) {
            element.jstree(true).settings.core.data = jsonData;
            element.jstree(true).refresh();
        }
        console.log('END FUNCTION: RVwys.rigthbar.isJstree.refresh');
    };

    RVwys.rigthbar.isJstree.updatemenu = function (oldslug, data) {
        var ele =
            $(
                `#selected_navigator li[menu-slug='${oldslug}'][slug-id='${data.slug_id}']`
            ).length > 0
                ? $(
                      `#selected_navigator li[menu-slug='${oldslug}'][slug-id='${data.slug_id}']`
                  )
                : $('#frameBody')
                      .get(0)
                      .contentWindow.$(
                          `#selected_navigator li[menu-slug='${oldslug}'][slug-id='${data.slug_id}']`
                      );

        var NavIcon = $(ele.find('span i')[0]).prop('outerHTML');
        var downIcon =
            ele.find('span .uk-icon-caret-down').length > 0
                ? $(ele.find('span .uk-icon-caret-down')[0]).prop('outerHTML')
                : '';

        ele.children('a')
            .children('span')
            .html(NavIcon + ' ' + data.page_name + downIcon);
        ele.attr('menu-slug', data.slug_name);
        ele.attr('menu-title', data.page_name);
        ele.attr('url', data.url);
    };

    RVwys.rigthbar.isJstree.PostCatagories = function () {
        $('#Countcategory').text(parent.wex.blog.blog_categories.length);

        var UI = parent.UIkit;

        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var modal = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>' +
                    rvLang('Blog Catagory') +
                    '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                '<div class="uk-margin uk-modal-content uk-overflow-container"><div>' +
                    $('#omodalBlog').html() +
                    '</div></div>',
                '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                    rvLang('Save') +
                    '</button>',
                '<button class="uk-button js-modal-confirm-cancel">' +
                    rvLang('Cancel') +
                    '</button></div>',
            ].join(''),
            options
        );
        modal.element.find('.uk-button-success').on('click', function () {
            onInsert();
        });

        modal.element.find('.js-modal-confirm-cancel').on('click', function () {
            oncancel();
        });

        modal.show();

        var element = modal.element.find('#sortcat');

        $.each(parent.wex.blog.blog_categories, function (k, v) {
            parent.wex.blog.blog_categories[k]['state'] = {
                opened: true,
            };
        });

        element
            .jstree({
                core: {
                    data: parent.wex.blog.blog_categories,
                    check_callback: function (
                        operation,
                        node,
                        node_parent,
                        node_position,
                        more
                    ) {
                        if (more && more.dnd && more.pos !== 'i') {
                            return false;
                        }

                        return true;
                    },
                },
                types: {
                    default: {
                        icon: 'uk-icon-folder-open-o',
                        max_depth: 3,
                    },
                },
                plugins: ['dnd', 'types'],
            })
            .on('loaded.jstree', function (event, data) {});

        oncancel = function () {
            modal.hide();
        };

        var onInsert = function () {
            var jstreeCat = element.jstree(true).get_json('#', {
                flat: true,
            });
            var obj = {};
            var arrBlog = [];

            $.each(jstreeCat, function (key, data) {
                var parent_id =
                    data.parent == '#' ? '0' : data.parent.match(/[0-9]/)[0];
                var matchId = data.id.match(/[0-9]/);
                var id = parseInt(matchId);
                obj = {
                    id: id,
                    parent_id: parent_id,
                    category_name: data.text,
                };
                arrBlog.push(obj);

                // Update wex.blog.blog_listscategory
                var indexCat = $.map(
                    parent.wex.blog.blog_categories,
                    function (obj, index) {
                        return obj.id;
                    }
                ).indexOf(data.id);

                parent.wex.blog.blog_categories[indexCat].parent = data.parent;
            });

            axiosAPICategory
                .axiosEditCategory({
                    arrblog: arrBlog,
                })
                .then(resposnse => {
                    var data = resposnse.data;
                    parent.console.pop[data.status]({
                        text: data.status,
                        delay: 2000,
                    });

                    modal.hide();
                })
                .catch(err => {
                    console.pop.error({
                        text: `Status Code: ${err.status} ( ${err.statusText} )`,
                        delay: 5000,
                    });
                });
        };
    };

    RVwys.rigthbar.isJstree.EventBlog = function (oThis) {
        var isBlogIndex = oThis.attr('indexkey') == '0';
        var ischild = oThis.attr('is-child');
        // Specifically blogindex

        var isPublic = oThis.attr('is-published') == 1;
        var isHome = oThis.attr('is-homepage') == 'true';
        console.log('oThis: ', oThis);
        console.log('isHome: ', isHome);
        var parentPublic =
            oThis.parent().closest('li').attr('is-published') == 1;

        parent.$('#blog_setHomePage').toggle(!isHome);

        parent.$('#blog_setHide').toggle(isPublic);
        parent.$('#blog_unsetHide').toggle(!isPublic);
        // }

        parent.$('#blog_delete').toggle(!isBlogIndex);
        // End Specifically blogindex
        $('.rename-title#category-name').toggle(!isBlogIndex);
        $('.rename-title#blogIndex-name').toggle(isBlogIndex);

        ischild == 'true'
            ? parent.$('#blog_delete').addClass('disable-delete')
            : parent.$('#blog_delete').removeClass('disable-delete');

        parent.$('.rvsb-design-property').hide();
        parent.$('#blog_title').text(window.activeBlogname);
        parent.$('.blogSetting').show();

        var positionsetting = oThis.position();

        var Maxh = screen.height - positionsetting.top;
        if (Maxh < 350) {
            parent.$('.blogSetting').css({
                right: '200px',
                top: '410',
            });
        } else {
            parent.$('.blogSetting').css({
                right: '200px',
                top: positionsetting.top - 5,
            });
        }
    };

    RVwys.rigthbar.isJstree.Recently = function () {
        $.each(parent.wex.page.page_recently, function (k, v) {
            parent.wex.page.page_recently[k]['type'] = 'default';
            parent.wex.page.page_recently[k]['li_attr'] = {
                'value-post': v.text,
            };
            parent.wex.page.page_recently[k]['a_attr'] = {
                href: parent.wex.url.WYS_SHOW_URL + '/' + v.slug_name,
            };
        });
        var _selectedNodeId;

        parent.$('#RecentPage').jstree({
            core: {
                data: parent.wex.page.page_recently,
            },
            types: {
                default: {
                    icon: 'icon-visibility parent-normal',
                },
            },
            plugins: ['types', 'wholerow', 'changed'],
        });

        parent.$('#RecentPage').bind('select_node.jstree', function (e, data) {
            var href = data.node.a_attr.href;
            parent.window.location.href = href;
            /*	 var val = data.node.li_attr["value-post"];
		 if ( _selectedNodeId === data.node.id ) {
		        data.instance.deselect_node(data.node);
		        _selectedNodeId = "";
		        val = '';
		    } else {
		        _selectedNodeId = data.node.id;
		    }

		$('#listpage_onmenu,#listpage_internal').jstree('search',val);*/
        });
    };

    RVwys.rigthbar.isJstree.CallbackoptionBlog = function (data, typeoption) {
        console.log('RVwys.rigthbar.isJstree.CallbackoptionBlog');

        var currentSlugID = data.slug_id;
        var indexBlog = RVwys.rigthbar.findIndexKey(
            wex.blog.blog_listscategory,
            'slug_id',
            currentSlugID
        );

        console.log(currentSlugID);
        console.log(indexBlog);

        switch (typeoption) {
            case 'sethide':
                // statusIcon: "bpost-normal-hide", type: "hide"
                var type = 'hide';

                RVwys.rigthbar.isJstree.setHideAndUnhide(
                    currentSlugID,
                    indexBlog,
                    typeoption,
                    type
                );
                wex.blog.blog_listscategory[indexBlog].is_published = 0;

                RVwys.rigthbar.isJstree.refreshBlog();

                break;

            case 'unsethide':
                // statusIcon: "bpost-normal"  type:"default"
                type = 'default';

                RVwys.rigthbar.isJstree.setHideAndUnhide(
                    currentSlugID,
                    indexBlog,
                    typeoption,
                    type
                );
                wex.blog.blog_listscategory[indexBlog].is_published = 1;

                var listblog = [
                    ...wex.blog.blog_lists,
                    ...wex.blog.blog_listscategory,
                ];

                RVwys.rigthbar.isJstree.refreshBlog();
                break;

            default:
                // refresh jstree

                break;
        }

        $('.blogSetting').hide();
    };

    RVwys.rigthbar.responseOptionCategory.setHomepage = async function (data) {
        var pageIsHomepage = wex.page.page_tree.find(
            ({ is_homepage }) => is_homepage == 1
        );
        if (pageIsHomepage.length) {
            // var dataPageTree = await axiosAPIPage.wexPageTree();
            // wex.page.page_tree = dataPageTree;
            pageIsHomepage.is_homepage = 0;
            pageIsHomepage.type = 'page';
            pageIsHomepage.statusIcon = 'parent-normal';

            await RVwys.rigthbar.isJstree.refreshPage();
        }

        // TODO: API RESPONSE DATA VERY SLOW. @Netway-Warithar
        var postIsHomepage = wex.blog.blog_lists.find(
            ({ is_homepage }) => is_homepage == 1
        );

        if (postIsHomepage) {
            // const blogLists = await axiosAPIBlog.wexBlogList();
            // wex.blog.blog_lists = blogLists;
            postIsHomepage.is_homepage = 0;
            postIsHomepage.type = 'post';
            postIsHomepage.statusIcon = 'bpost-normal';
        }

        const blogCategoryList = await axiosAPIBlog.wexBlogCategoryList();
        wex.blog.blog_listscategory = blogCategoryList;

        await RVwys.rigthbar.isJstree.refreshBlog();
    };

    RVwys.rigthbar.responseOptionCategory.setHide = async function (data) {
        console.log('RVwys.rigthbar.responseOptionCategory.setHide');

        var isSlug_ID = data.slug_id;
        var categoryHide = wex.blog.blog_listscategory.find(
            ({ slug_id }) => slug_id == isSlug_ID
        );

        categoryHide.is_published = 0;
        categoryHide.type = `${categoryHide.type}-hide`;
        categoryHide.statusIcon = `${categoryHide.statusIcon}-hide`;

        RVwys.rigthbar.recursiveHidePost(categoryHide.id);
        RVwys.rigthbar.isJstree.refreshBlog();
    };

    RVwys.rigthbar.recursiveHidePost = function (ParentID) {
        // console._method('RVwys.rigthbar.recursiveHidePost');
        var postChildHide = wex.blog.blog_lists.filter(
            ({ parent }) => parent == ParentID
        );

        if (postChildHide.length) {
            $.map(postChildHide, function (valueInPost) {
                valueInPost.is_published = 0;
                valueInPost.type = `${valueInPost.type}-hide`;
                valueInPost.statusIcon = `${valueInPost.statusIcon}-hide`;
            });
        }

        var categoryChildHide = wex.blog.blog_listscategory.filter(
            ({ parent }) => parent == ParentID
        );
        if (categoryChildHide.length) {
            RVwys.rigthbar.recursiveHideCategory(ParentID);
        }
    };

    RVwys.rigthbar.recursiveHideCategory = function (ParentID) {
        // console._method('RVwys.rigthbar.recursiveHideCategory ');

        var categoryChildHide = wex.blog.blog_listscategory.filter(
            ({ parent }) => parent == ParentID
        );

        if (categoryChildHide.length) {
            for (let i = 0; i < categoryChildHide.length; i++) {
                categoryChildHide[i].is_published = 0;
                categoryChildHide[i].type = `${categoryChildHide[i].type}-hide`;

                var statusIcon = `${categoryChildHide[i].statusIcon}-hide`;
                categoryChildHide[i].statusIcon = statusIcon;

                RVwys.rigthbar.recursiveHidePost(categoryChildHide[i].id);
            }
        }
    };

    RVwys.rigthbar.responseOptionCategory.setUnHide = async function (data) {
        // console._method('RVwys.rigthbar.responseOptionCategory.setUnHide');

        var isSlug_ID = data.slug_id;
        var categoryUnHide = wex.blog.blog_listscategory.find(
            ({ slug_id }) => slug_id == isSlug_ID
        );

        categoryUnHide.is_published = 1;
        categoryUnHide.type = categoryUnHide.type.replace('-hide', '');
        categoryUnHide.statusIcon = categoryUnHide.statusIcon.replace(
            '-hide',
            ''
        );

        RVwys.rigthbar.recursiveUnHidePost(categoryUnHide.id);

        await RVwys.rigthbar.isJstree.refreshBlog();
    };

    RVwys.rigthbar.recursiveUnHidePost = function (ParentID) {
        console.log('RVwys.rigthbar.recursiveUnHidePost ');

        var postChildHide = wex.blog.blog_lists.filter(
            ({ parent }) => parent == ParentID
        );

        var categoryChildHide = wex.blog.blog_listscategory.filter(
            ({ parent }) => parent == ParentID
        );
        if (postChildHide.length) {
            $.map(postChildHide, function (valueInPost) {
                valueInPost.is_published = 1;
                valueInPost.type = valueInPost.type.replace('-hide', '');
                valueInPost.statusIcon = valueInPost.statusIcon.replace(
                    '-hide'
                );
            });
        }
        if (categoryChildHide.length) {
            RVwys.rigthbar.recursiveUnHideCategory(ParentID);
        }
    };

    RVwys.rigthbar.recursiveUnHideCategory = function (ParentID) {
        console.log('RVwys.rigthbar.recursiveUnHideCategory ');
        var categoryChildUnHide = wex.blog.blog_listscategory.filter(
            ({ parent }) => parent == ParentID
        );

        if (categoryChildUnHide) {
            $.map(categoryChildUnHide, function (valueInCategory) {
                valueInCategory.is_published = 1;
                valueInCategory.type = valueInCategory.type.replace(
                    '-hide',
                    ''
                );
                valueInCategory.statusIcon = valueInCategory.statusIcon.replace(
                    '-hide',
                    ''
                );

                var postChildHide = wex.blog.blog_lists.filter(
                    ({ parent }) => parent == valueInCategory.id
                );

                if (postChildHide) {
                    RVwys.rigthbar.recursiveUnHidePost(valueInCategory.id);
                }
            });
        }
    };

    RVwys.rigthbar.isJstree.refreshBlog = async function () {
        /*
         * TODO: Refactoring API WEX.BLOG - @Netway-Warithar
         */
        // const blogLists = await axiosAPIBlog.axiosAPIBlogList();
        // const blogCategoryList = await axiosAPIBlog.axiosAPIBlogCategoryList();

        const blogLists = wex.blog.blog_lists;
        const blogCategoryList = wex.blog.blog_listscategory;
        var objBlog = {
            blogLists,
            blogCategoryList,
        };
        RVwys.rigthbar.isJstree.refresh($('#listblog'), objBlog, 'blog');
    };

    RVwys.rigthbar.isJstree.refreshPage = function () {
        var objPage = { page: wex.page.page_tree };
        RVwys.rigthbar.isJstree.refresh($('#listpage_onmenu'), objPage, 'page');
    };

    RVwys.rigthbar.isJstree.refreshRecently = function (obj, elem) {
        var objRecently = { recently: obj };
        RVwys.rigthbar.isJstree.refresh($(`#${elem}`), objRecently, 'recently');
    };

    RVwys.rigthbar.isJstree.refreshMenu = function () {
        var objMenu = { menu: wex.menu.menu_tree };
        RVwys.rigthbar.isJstree.refresh($('#listmenu'), objMenu, 'menu');
    };

    RVwys.rigthbar.findIndexKey = function (listData, keyword, keywordMap) {
        return $.map(listData, function (obj) {
            return obj[keyword];
        }).indexOf(+keywordMap);
    };

    RVwys.rigthbar.isJstree.setHideAndUnhide = function (
        slugid,
        indexBlog,
        status,
        type
    ) {
        console.log('RVwys.rigthbar.isJstree.setHideAndUnhide');

        var blog = {
            post: 'blog_lists',
            category: 'blog_listscategory',
        };

        var iconCate = status == 'sethide' ? 'hidecategory' : 'category';
        var typeoption = status == 'sethide' ? 0 : 1;
        $.each(blog, function (indexInBlog, valueOfBlog) {
            type = indexInBlog == 'post' ? type : iconCate;
            if (window.blogindex) {
                $.each(
                    wex.blog[valueOfBlog],
                    function (indexInArray, valueOfElement) {
                        if (valueOfElement.slug_id != slugid) {
                            valueOfElement.type = type;
                        }
                    }
                );

                wex.blog.blog_listscategory[indexBlog].type = type;
            } else {
                var slug_name =
                    wex.blog.blog_listscategory[indexBlog].slug_name;
                $.each(
                    wex.blog[valueOfBlog],
                    function (indexInArray, valueOfElement) {
                        if (valueOfElement.category_slug_name == slug_name) {
                            valueOfElement.type = type;
                            valueOfElement.is_published = typeoption;
                        }
                    }
                );
                wex.blog.blog_listscategory[indexBlog].type = type;
            }
        });
    };

    // Update wex category from call API.@Netway-Warithar
    RVwys.rigthbar.responseOptionCategory.setHideOrUnhide = async function () {
        const blogLists = await axiosAPIBlog.wexBlogList();
        wex.blog.blog_lists = blogLists;
        const blogCategoryList = await axiosAPIBlog.wexBlogCategoryList();
        wex.blog.blog_listscategory = blogCategoryList;

        await RVwys.rigthbar.isJstree.refreshBlog();
    };

    RVwys.rigthbar.callBlogAPI = async function () {
        /*
         * TODO: Refactoring API WEX.BLOG - @Netway-Warithar
         */
        // if (!wex.hasOwnProperty.call(wex.blog, 'blog_lists')) {
        // wex['blog']['blog_lists'] = await axiosAPIBlog.axiosAPIBlogList();
        // }

        // if (!wex.hasOwnProperty.call(wex.blog, 'blog_listscategory')) {
        // wex['blog']['blog_listscategory'] = await axiosAPIBlog.axiosAPIBlogCategoryList();
        // }

        // if (!wex.hasOwnProperty.call(wex.blog, 'blog_recently')) {
        // wex['blog']['blog_recently'] = await axiosAPIBlog.axiosAPIBlogRecently();
        // }

        const blogLists = wex.blog.blog_lists;
        const blogCategoryList = wex.blog.blog_listscategory;
        var objBlog = {
            blogLists,
            blogCategoryList,
        };

        RVwys.rigthbar.isJstree.createJSTrees($('#listblog'), objBlog, {
            type: 'blog',
            iconType: customIconJStree.JStreeTypeIconBlog(),
        });
    };

    RVwys.rigthbar.isJstree.blog.findObjectOfKey = function (slugID) {


        var objUpdate = wex.blog.blog_lists.find(
            ({ slug_id }) => slug_id == slugID
        );

        if (!objUpdate) {
            var objCategoryUpdate = wex.blog.blog_listscategory.find(
                ({ slug_id }) => slug_id == slugID
            );
            return {objCategoryUpdate} ;
        }
        var objRecently = wex.blog.blog_recently.find(
            ({ slug_id }) => slug_id == slugID
        );
        return { objRecently, objUpdate };
    };

    RVwys.rigthbar.isJstree.page.findObjectOfKey = function (slugID) {
        var objUpdate = wex.page.page_tree.find(
            ({ slug_id }) => slug_id == slugID
        );
        var objRecently = wex.page.page_recently.find(
            ({ slug_id }) => slug_id == slugID
        );
        return { objRecently, objUpdate };
    };

    RVwys.designViewAddEvent('mousedown', function (e) {
        // parent.$('.rvsb-design-property').hide();
        // parent.$('.rvsb-design-bar-right').addClass()
    });
})(jQuery);
